var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html } from "lit";
import { customElement, state } from "lit/decorators.js";
import { DataStore } from "../services/datastore.service";
let AppLogin = class AppLogin extends LitElement {
    constructor() {
        super();
        this._username = "";
        this._password = "";
        this.loading = false;
        this.notification = undefined;
        this.keydownHandler = (e) => {
            if (e.keyCode == 13) {
                this.login();
            }
        };
        this.datastore = DataStore.getInstance();
    }
    connectedCallback() {
        super.connectedCallback();
        window.addEventListener("keydown", this.keydownHandler);
    }
    disconnectedCallback() {
        window.removeEventListener("keydown", this.keydownHandler);
        super.disconnectedCallback();
    }
    createRenderRoot() {
        return this;
    }
    updateValues() {
        this._username = document.getElementById("username").value;
        this._password = document.getElementById("password").value;
    }
    login() {
        this.updateValues();
        this.loading = true;
        this.datastore
            .fetchOidcLogin(this._username, this._password)
            .catch((error) => {
            this.notification = JSON.parse(error.body).errortext;
        })
            .finally(() => {
            this.loading = false;
        });
    }
    clearNotification() {
        this.notification = undefined;
    }
    render() {
        return html `
      <div class="card">
        <div class="card-content">
          <div class="mt-2 mb-2 text-centered">
            <div class="field">
              <div class="control has-icons-left has-icons-right">
                <input id="username" class="input" type="text" placeholder="Email" />
                <span class="icon is-small is-left">
                  <i class="fas fa-at"></i>
                </span>
              </div>
            </div>

            <div class="field">
              <div class="control has-icons-left has-icons-right">
                <input id="password" class="input" type="password" placeholder="Password" />
                <span class="icon is-small is-left">
                  <i class="fas fa-lock"></i>
                </span>
              </div>
            </div>

            <div class="container is-fluid p-0 is-clearfix">
              <button class="button is-primary is-pulled-left" @click="${this.login}" ?disabled=${this.loading}>
                <span class="icon"> ${this.loading ? html ` <i class="fas fa-circle-notch fa-spin"></i> ` : html ` <i class="fas fa-key"></i> `} </span>
                <span>Login</span>
              </button>
              <a href="reset">
                <button class="button is-secondary is-pulled-right" ?disabled=${this.loading}>
                  <span class="icon"><i class="fas fa-question"></i></span>
                  <span>Forgotten</span>
                </button>
              </a>
            </div>

            ${this.notification
            ? html `
                  <div class="notification is-warning mt-4 has-text-centered">
                    <button class="delete" @click="${this.clearNotification}"></button>
                    ${this.notification}
                  </div>
                `
            : ""}
          </div>
        </div>
      </div>
    `;
    }
};
__decorate([
    state()
], AppLogin.prototype, "loading", void 0);
__decorate([
    state()
], AppLogin.prototype, "notification", void 0);
AppLogin = __decorate([
    customElement("app-login")
], AppLogin);
export { AppLogin };
//# sourceMappingURL=anon_login.js.map